/**
 * Standard parish dropdown label:
 * ParishName (uniqueId) | city | parishCategoryName
 * If uniqueId is missing, the name is shown without parentheses.
 * Use omitCategory: true for OTHER-category groups (ParishName (uniqueId) | city).
 */
export function formatParishOptionLabel(item, options = {}) {
  if (!item) return "";
  const { omitCategory = false } = options;
  const name = item.parish || "";
  const uidRaw = item.uniqueId;
  const uid =
    uidRaw != null && String(uidRaw).trim() !== ""
      ? String(uidRaw).trim()
      : null;
  const nameWithId = uid ? `${name} (${uid})` : name;

  const city = item.city;
  const cat = omitCategory ? null : item.parishCategoryName;

  const extras = [city, cat].filter(Boolean);
  if (extras.length === 0) {
    return nameWithId || "No details available";
  }
  return `${nameWithId} | ${extras.join(" | ")}`;
}
